import React, { useState } from "react";
import { message as toast } from "antd";
import { useTranslation } from "react-i18next";
import Avatar from "@/components/Avatar";
import { changeEgovUrl } from "@/utils/tools";
import { joinMeeting, joinLive, avsdkNameMap, openRecord } from "@/baseComponents/Meeting/utils";

import { AVSDK } from "@/baseComponents/Meeting/common";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import { FocusSDK, isFocusEnv } from "@/utils";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { handleLinkClick } from "./utils";
import { useHistory } from "react-router-dom";

const WEB_NOT_SUPORT = ["znhysumm", "voicemeeting"];

function MeetingNoticeCard({ message }: any) {
  const [t] = useTranslation("chat");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { title = "", content = "", infox = {}, extend = {} } = message;
  const deepLink = DeeplinkEvent.parseDeeplink(infox.deepLink);
  const mparams = deepLink?.mparam || {};

  const avsdk = mparams.avsdk as AVSDK;

  function handleJoin() {
    if (loading) {
      return;
    }
    setLoading(true);
    joinMeeting(avsdk, {
      meetingNumber: infox.meetingNumber || mparams.meetingNumber,
      meetingPassword: infox.password || mparams.meetingPassword
    })
      .catch((err) => {
        toast.error(err.message || err);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function handleOpenRecord(type = 0) {
    openRecord({ meetingId: mparams.meetingId, history, type, action: "summaryDetail" });
  }

  function handleJoinLive() {
    joinLive(
      avsdk,
      {
        liveCode: mparams.liveCode,
        livePassword: mparams.livePassword,
        name: extend.applicationName,
        icon: changeEgovUrl(message.sender.avatar)
      },
      history
    ).catch((e) => {
      toast.error(e.message || e || "未知错误");
    });
  }

  function handleClick() {
    // 智能摘要
    if (infox.action === "znhysumm") {
      handleOpenRecord();
      return;
    }
    if (infox.action === "notesumm") {
      handleOpenRecord(1);
      return;
    }
    if (infox.action === "joinmeeting") {
      if (avsdk.toLowerCase().includes("live")) {
        handleJoinLive();
      } else {
        handleJoin();
      }
    } else if (extend.url) {
      handleLinkClick(extend.url);
    } else {
      console.info("infox.action", infox.action);
      FocusSDK.printLog("unknown meeting notice card", infox.action);
      toast.warn("当前版本暂不支持，请升级至最新版本");
    }
  }

  function loadButtons() {
    if (!isFocusEnv() && WEB_NOT_SUPORT.includes(infox.action)) {
      return null;
    }
    // 按钮展示逻辑，加入会议或者查看详情
    if (infox.action === "joinmeeting") {
      let platform = FocusSDK.getDeviceInfo().platform;
      if (platform !== "win32") {
        if (avsdk === AVSDK.XYLINK || avsdk === AVSDK.HUAWEI) {
          return null;
        }
      }
    }

    if (infox.btnName || extend.url) {
      return (
        <div
          className="button_item"
          onClick={() => {
            handleClick();
          }}
        >
          {infox.btnName || "查看详情"}
        </div>
      );
    }
    return null;
  }

  if (extend.messageFormatVer === "v2") {
    return (
      <ComNoticeCard
        message={message}
        avatarSrc={changeEgovUrl(message.sender.avatar)}
        type={extend.applicationName}
        contentList={extend.fields}
        title={title}
        loadButtonsFn={loadButtons}
      />
    );
  }
  const fromUser = mparams.fromUser;

  return (
    <div className="notice-card notice-card-cloudlink">
      <div className="notice-card-header">
        <div className="notice-card-title">
          {avsdk ? `${avsdkNameMap[avsdk]}-` : ""}
          {title}
        </div>
        {content && <div className="notice-card-content">{content}</div>}
      </div>
      {fromUser && (
        <div className="notice-card-from">
          <Avatar
            style={{
              borderRadius: "50%",
              width: 26,
              height: 26,
              marginRight: 5
            }}
            src={changeEgovUrl(fromUser.avatar)}
          />
          <span>{fromUser.name}</span>
        </div>
      )}
      {mparams.avsdk && (
        <div className="notice-card-action">
          <div className="notice-card-action-view" onClick={handleJoin}>
            {t("joyMeeting.joinMeeting")}
          </div>
        </div>
      )}
    </div>
  );
}

export default MeetingNoticeCard;
